var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.037,
    height: 14.729,
    viewBox: "0 0 21.037 14.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M20.6,79.306a2.636,2.636,0,0,0-1.854-1.854C17.1,77,10.518,77,10.518,77s-6.585,0-8.231.433A2.689,2.689,0,0,0,.433,79.306a29.767,29.767,0,0,0,0,10.12A2.636,2.636,0,0,0,2.287,91.28c1.663.451,8.231.451,8.231.451s6.585,0,8.231-.433A2.635,2.635,0,0,0,20.6,89.443a27.773,27.773,0,0,0,.433-5.06A26.361,26.361,0,0,0,20.6,79.306ZM8.422,87.519V81.212L13.9,84.366Z",
    transform: "translate(0 -77.001)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeW);
export default __webpack_public_path__ + "static/media/Youtube-W.bbe47743b8831588438cb5657facd304.svg";
export { ForwardRef as ReactComponent };